import React from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import FooterOne from '../../../../assets/images/footer_1.png';
import FooterTwo from '../../../../assets/images/footer_2.png';
import FooterThree from '../../../../assets/images/footer_3.png';
import FooterFour from '../../../../assets/images/footer_4.png';
import FooterFive from '../../../../assets/images/footer_5.png';
import FooterSix from '../../../../assets/images/footer_6.png';
import { privacyRoute /* , consentRoute */ } from '../../../../routes';
import Link from '../../../Link';

import './style/footer.css';

export default function Footer() {
  return (
    <footer className="footer-container container-fluid">
      <Container>
        <Row>
          <Col md={4} className="footer-left">
            <img alt="" src={FooterOne} className="img-responsive" />
            <img alt="" src={FooterTwo} className="img-responsive" />
            <img alt="" src={FooterThree} className="img-responsive" />
            <img alt="" src={FooterFour} className="img-responsive" />
            <img alt="" src={FooterFive} className="img-responsive" />
            <img alt="" src={FooterSix} className="img-responsive" />
          </Col>
          <Col md={4} className="footer-center">
            <Link to={privacyRoute}>Informativa sulla Privacy</Link>
            {/* TODO: Mostrare solo in metabolico? */}
            {/* <Link to={consentRoute}>Informativa sullo Screening Neonatale</Link>  */}
          </Col>
          <Col md={4} className="footer-right" />
        </Row>
      </Container>
    </footer>
  );
}
